module.exports = __webpack_public_path__ + "static/our-services-d423e901ff26986eb4244fe9c4245e9b.jpg";